const productsBrowserSort = () => ({
  open: false,
  openDelayed: false,

  init() {
    this.$watch('open', async (open) => {
      await this.$nextTick();
      this.openDelayed = open;
    });
  },

  handleClickOutside() {
    if (this.openDelayed) {
      this.open = false;
    }
  },
});

export default productsBrowserSort;
